import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

export interface Timezone {
  value: string;
  abbr: string;
  offset: number;
  isdst: boolean;
  text: string;
  utc: string[];
}
interface TimezoneResponse {
  timezone: Timezone[];
}

@Injectable({
  providedIn: "root",
})
export class TimezoneService {
  private currentTimeZone = new BehaviorSubject<string>("");
  private currentOffset = new BehaviorSubject<number>(0);

  currentTimeZone$ = this.currentTimeZone.asObservable();
  currentOffset$ = this.currentOffset.asObservable();

  constructor(private http: HttpClient) {}

  public setLocale(locale: string) {
    this.currentTimeZone.next(locale);
  }

  public setOffset(offset: number) {
    this.currentOffset.next(offset);
  }
  // public getTimezoneCollection(): Observable<Timezone[]> {
  //   return this.http.get<TimezoneResponse>('assets/data/timezones.json')
  //     .pipe(item => item.map(value => this.buildArrayString(value)));
  // }

  public getTimezoneCollection(): Observable<Timezone[]> {
    return this.http.get<TimezoneResponse>(environment.assetsDataPath + "timezones.json").pipe(
      map<any, any[]>((item) => {
        const _timezone: Timezone[] = item.timezone;
        return _timezone;
      })
    );
  }

  private buildArrayString(responseCollection: TimezoneResponse): Timezone[] {
    debugger;
    if (!responseCollection.timezone) {
      return;
    }
    const auxTimezoneArray: Timezone[] = [];
    for (const timezone of responseCollection.timezone) {
      auxTimezoneArray.push(timezone);
    }
    return auxTimezoneArray;
  }
}
